/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type { IntlService } from 'ember-intl';
import type { ChatSuggestion } from 'walden-fast/types/chat';

export interface ChatSuggestionsArgs {
  onSend: (message: string) => void;
  setInputMessage: (message: string) => void;
  suggestions?: ChatSuggestion[];
}

export default class ChatSuggestionsComponent extends Component<ChatSuggestionsArgs> {
  @service('intl') declare intl: IntlService;

  @action
  handleSuggestionClick(suggestion: ChatSuggestion): void {
    if (suggestion.immediate) {
      this.args.onSend(suggestion.text);
    } else {
      this.args.setInputMessage(suggestion.text);
    }
  }
}
